import { IPreferenceType } from '../../notification_settings_interfacaes';
import { EditPhoneNumberService } from '../../services/edit_phone_number_service';

export class PhoneContactDetailsController {
  contactInfo: IPreferenceType;

  constructor(private notificationSettingEnum: any, private ngEditPhoneNumberService: EditPhoneNumberService) {}

  $onInit(): void {
    this.contactInfo = this.notificationSettingEnum.TEXT;
  }

  modalCallback() {
    this.ngEditPhoneNumberService.contactConfig = {};
    this.ngEditPhoneNumberService.toggleOpen(true);
  }
}

export class PhoneContactDetailsComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-notification-settings/src/components/phone_contact_details/phone_contact_details.html';
  public controller: any = PhoneContactDetailsController;
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/components/phone_contact_details/phone_contact_details_controller.ts